import {
  ROOT_URL,
  ASSET_SUBTYPES,
  INCIDENT_RESOLVER_STATE,
} from 'xm-constants/incidentManagement';
import forEach from 'lodash/forEach';
import { loadConferenceParticipants } from '@xmatters/redux/actions/conferences/conferenceActions';
import { isIncidentResolversOrderEnabled } from 'selectors/featureToggles';
import { updateServiceInList } from '../services';

const FAIL = 'FAIL';
const START = 'START';
const SUCCESS = 'SUCCESS';

const DISMISS_RESOLVER = 'DISMISS_RESOLVER';
const REMOVE_RESOLVER = 'REMOVE_RESOLVER';
export const REMOVE_RESOLVER_START = `${REMOVE_RESOLVER}_${START}`;
export const REMOVE_RESOLVER_SUCCESS = `${REMOVE_RESOLVER}_${SUCCESS}`;
export const REMOVE_RESOLVER_FAIL = `${REMOVE_RESOLVER}_${FAIL}`;
export const DISMISS_RESOLVER_SUCCESS = `${DISMISS_RESOLVER}_${SUCCESS}`;

export const ASSOCIATE_PARTICIPANTS_WITH_BRIDGE =
  'ASSOCIATE_PARTICIPANTS_WITH_BRIDGE';
export const RESET_PARTICIPANTS_ON_BRIDGES = 'RESET_PARTICIPANTS_ON_BRIDGES';
const FETCH_INCIDENT_DETAILS = 'FETCH_INCIDENT_DETAILS';
export const FETCH_INCIDENT_DETAILS_START = `${FETCH_INCIDENT_DETAILS}_${START}`;
export const FETCH_INCIDENT_DETAILS_SUCCESS = `${FETCH_INCIDENT_DETAILS}_${SUCCESS}`;
export const FETCH_INCIDENT_DETAILS_FAIL = `${FETCH_INCIDENT_DETAILS}_${FAIL}`;
export const RESET_INCIDENT_DETAILS = 'RESET_INCIDENT_DETAILS';

const FETCH_INCIDENT_DETAILS_AUTO = 'FETCH_INCIDENT_DETAILS_AUTO';
export const FETCH_INCIDENT_DETAILS_AUTO_START = `${FETCH_INCIDENT_DETAILS_AUTO}_${START}`;
export const FETCH_INCIDENT_DETAILS_AUTO_SUCCESS = `${FETCH_INCIDENT_DETAILS_AUTO}_${SUCCESS}`;
export const FETCH_INCIDENT_DETAILS_AUTO_FAIL = `${FETCH_INCIDENT_DETAILS_AUTO}_${FAIL}`;

const FETCH_COLLABORATIONS = 'FETCH_COLLABORATIONS';
export const FETCH_COLLABORATIONS_SUCCESS = `${FETCH_COLLABORATIONS}_${SUCCESS}`;

const FETCH_RESOLVERS = 'FETCH_RESOLVERS';
export const FETCH_RESOLVERS_SUCCESS = `${FETCH_RESOLVERS}_${SUCCESS}`;

const FETCH_RESOLVER_ROLES = 'FETCH_RESOLVER_ROLES';
export const FETCH_RESOLVER_ROLES_SUCCESS = `${FETCH_RESOLVER_ROLES}_${SUCCESS}`;

const FETCH_ORDERED_RESOLVERS_AND_ROLES = 'FETCH_ORDERED_RESOLVERS_AND_ROLES';
export const FETCH_ORDERED_RESOLVERS_AND_ROLES_SUCCESS = `${FETCH_ORDERED_RESOLVERS_AND_ROLES}_${SUCCESS}`;

export const CHANGE_RESOLVERS_ORDER = 'CHANGE_RESOLVERS_ORDER';

export const SAVE_RESOLVERS_ORDER = 'SAVE_RESOLVERS_ORDER';
export const SAVE_RESOLVERS_ORDER_START = `${SAVE_RESOLVERS_ORDER}_${START}`;
export const SAVE_RESOLVERS_ORDER_FAIL = `${SAVE_RESOLVERS_ORDER}_${FAIL}`;
export const SAVE_RESOLVERS_ORDER_SUCCESS = `${SAVE_RESOLVERS_ORDER}_${SUCCESS}`;

export const SAVE_INCIDENT_DETAILS = 'SAVE_INCIDENT_DETAILS';
export const SAVE_INCIDENT_DETAILS_START = `${SAVE_INCIDENT_DETAILS}_${START}`;
export const SAVE_INCIDENT_DETAILS_FAIL = `${SAVE_INCIDENT_DETAILS}_${FAIL}`;
export const SAVE_INCIDENT_DETAILS_SUCCESS = `${SAVE_INCIDENT_DETAILS}_${SUCCESS}`;

export const SET_INCIDENT_OWNER = 'SET_INCIDENT_OWNER';
export const SET_INCIDENT_OWNER_START = `${SET_INCIDENT_OWNER}_${START}`;
export const SET_INCIDENT_OWNER_SUCCESS = `${SET_INCIDENT_OWNER}_${SUCCESS}`;
export const SET_INCIDENT_OWNER_FAIL = `${SET_INCIDENT_OWNER}_${FAIL}`;

export const STOP_NOTIFYING_RESOLVER = 'STOP_NOTIFYING_RESOLVER';
export const STOP_NOTIFYING_RESOLVER_SUCCESS = `${STOP_NOTIFYING_RESOLVER}_${SUCCESS}`;
export const STOP_NOTIFYING_RESOLVERS = 'STOP_NOTIFYING_RESOLVERS';
export const STOP_NOTIFYING_RESOLVERS_SUCCESS = `${STOP_NOTIFYING_RESOLVERS}_${SUCCESS}`;
export const REFRESH_INCIDENT = 'REFRESH_INCIDENT';

export const CREATE_INCIDENT_ROLE = 'CREATE_INCIDENT_ROLE';
export const CREATE_INCIDENT_ROLE_START = `${CREATE_INCIDENT_ROLE}_${START}`;
export const CREATE_INCIDENT_ROLE_SUCCESS = `${CREATE_INCIDENT_ROLE}_${SUCCESS}`;
export const CREATE_INCIDENT_ROLE_FAIL = `${CREATE_INCIDENT_ROLE}_${FAIL}`;

export const REMOVE_RESOLVER_FROM_ROLE = 'REMOVE_RESOLVER_FROM_ROLE';

export const ADD_RESOLVER_TO_ROLE = 'ADD_RESOLVER_TO_ROLE';
export const ADD_RESOLVER_TO_ROLE_START = `${ADD_RESOLVER_TO_ROLE}_${START}`;
export const ADD_RESOLVER_TO_ROLE_SUCCESS = `${ADD_RESOLVER_TO_ROLE}_${SUCCESS}`;
export const ADD_RESOLVER_TO_ROLE_FAIL = `${ADD_RESOLVER_TO_ROLE}_${FAIL}`;

export const DELETE_INCIDENT_ROLE = 'DELETE_INCIDENT_ROLE';
export const DELETE_INCIDENT_ROLE_START = `${DELETE_INCIDENT_ROLE}_${START}`;
export const DELETE_INCIDENT_ROLE_SUCCESS = `${DELETE_INCIDENT_ROLE}_${SUCCESS}`;
export const DELETE_INCIDENT_ROLE_FAIL = `${DELETE_INCIDENT_ROLE}_${FAIL}`;

export const RENAME_INCIDENT_ROLE = 'RENAME_INCIDENT_ROLE';
export const RENAME_INCIDENT_ROLE_START = `${RENAME_INCIDENT_ROLE}_${START}`;
export const RENAME_INCIDENT_ROLE_SUCCESS = `${RENAME_INCIDENT_ROLE}_${SUCCESS}`;
export const RENAME_INCIDENT_ROLE_FAIL = `${RENAME_INCIDENT_ROLE}_${FAIL}`;

export const CLEAR_INCIDENT_ROLE_ERROR = 'CLEAR_INCIDENT_ROLE_ERROR';
export const SET_INCIDENT_ROLES_ERROR = 'SET_INCIDENT_ROLES_ERROR';

const ADD_RESOLVERS = 'ADD_RESOLVERS';
const RENOTIFY_RESOLVER = 'RENOTIFY_RESOLVER';

export const ADD_RESOLVERS_SUCCESS = `${ADD_RESOLVERS}_${SUCCESS}`;

const ADD_STAKEHOLDERS = 'ADD_STAKEHOLDERS';
export const ADD_STAKEHOLDERS_SUCCESS = `${ADD_STAKEHOLDERS}_${SUCCESS}`;

const FETCH_STAKEHOLDERS = 'FETCH_STAKEHOLDERS';
export const FETCH_STAKEHOLDERS_SUCCESS = `${FETCH_STAKEHOLDERS}_${SUCCESS}`;
export const FETCH_STAKEHOLDERS_FAIL = `${FETCH_STAKEHOLDERS}_${FAIL}`;

const DELETE_STAKEHOLDERS = 'DELETE_STAKEHOLDERS';
export const DELETE_STAKEHOLDER_LOCALLY = 'DELETE_STAKEHOLDER_LOCALLY';

const NOTIFY_STAKEHOLDERS = 'NOTIFY_STAKEHOLDERS';
export const NOTIFY_STAKEHOLDERS_FAIL = `${NOTIFY_STAKEHOLDERS}_${FAIL}`;
export const NOTIFY_STAKEHOLDERS_START = `${NOTIFY_STAKEHOLDERS}_${START}`;
export const NOTIFY_STAKEHOLDERS_SUCCESS = `${NOTIFY_STAKEHOLDERS}_${SUCCESS}`;
export const SET_SELECTED_SERVICE_OWNER_RESOLVER =
  'SET_SELECTED_SERVICE_OWNER_RESOLVER';

export const SET_MOCK_ROLE = 'SET_MOCK_ROLE';

export const MOVE_RESOLVER_WITHIN_ROLES = 'MOVE_RESOLVER_WITHIN_ROLES';

// Can use both user specified incident_id or server generated UUID. They have a 1-to-1 mapping.
/**
 * Fetch the details about an incident. This only includes fields like summary, description, createAt, status, etc.
 * It doesn't fetch collaboration or resolvers; they are done in other action creators because they're returned from other endpoints.
 * @param {string} id - Can use both incident_id (incidentIdentifier) or server generated UUID. They have a 1-to-1 mapping.
 * @param {boolean} auto
 * @param {boolean} includeServiceMetrics Required for FF enabling/disabling (will alter the request to include additional metrics)
 */
export function fetchIncident(id, auto = false, params = {}) {
  return {
    type: auto ? FETCH_INCIDENT_DETAILS_AUTO : FETCH_INCIDENT_DETAILS,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(id)}`,
      method: 'get',
      params,
    },
  };
}

export function fetchIncidentPlusUpdates(id, auto = false, params = {}) {
  return async dispatch => {
    const result = await dispatch(fetchIncident(id, auto, params));
    const { impactedServices } = result?.payload;
    forEach(impactedServices, updatedService =>
      dispatch(updateServiceInList(updatedService)),
    );
    return result?.payload;
  };
}

export function resetIncidentDetails() {
  return { type: RESET_INCIDENT_DETAILS };
}

/**
 * Fetch the collaborations (such as Slack, Conference, etc) for the current incident.
 * Server calls it "communications", but ProdComms renamed this to "Collaboration", hence the naming difference.
 * @param id - incident_id or uuid.
 */
export function fetchCollaborations(id) {
  return {
    type: FETCH_COLLABORATIONS,
    meta: {
      xmApi: true,
      // We could also call /assets?subtype=communications. /communications is like an alias
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(id)}/communications`,
      method: 'get',
    },
  };
}

const associateParticipantsWithBridge = (bridgeId, participants) => ({
  type: ASSOCIATE_PARTICIPANTS_WITH_BRIDGE,
  bridgeId,
  participants,
});

export function fetchCollaborationsAndConferenceParticipantsPr(id) {
  return dispatch => {
    return dispatch(fetchCollaborations(id)).then(collabs => {
      const conferences = collabs?.payload.data.filter(
        collab => collab.assetSubType === ASSET_SUBTYPES.XM_BRIDGE,
      );
      if (Array.isArray(conferences)) {
        const confParticipants = conferences.map(conf => {
          // For every conference bridge we also need to get the participants
          const { bridgeId } = conf.details;
          return dispatch(loadConferenceParticipants(bridgeId)).then(
            participants => {
              const participantList = participants.payload.data;
              const currentParticipants = participantList.filter(
                participant => participant?.left === undefined,
              );
              return dispatch(
                associateParticipantsWithBridge(bridgeId, currentParticipants),
              );
            },
          );
        });
        return Promise.all(confParticipants);
      }
      return Promise.resolve();
    });
  };
}

export const fetchCollaborationsAndConferenceParticipants =
  id => async dispatch => {
    const collabs = await dispatch(fetchCollaborations(id));
    const conferences = collabs?.payload.data.filter(
      collab => collab.assetSubType === ASSET_SUBTYPES.XM_BRIDGE,
    );
    return Promise.all(
      conferences.map(async conference => {
        const { bridgeId } = conference.details;
        const participants = await dispatch(
          loadConferenceParticipants(bridgeId),
        );
        const participantList = participants.payload.data;
        const currentParticipants = participantList.filter(
          participant => participant?.left === undefined,
        );

        return dispatch(
          associateParticipantsWithBridge(bridgeId, currentParticipants),
        );
      }),
    );
  };

/**
 * Fetch all resolvers for the current incident.
 * @param id - incident_id or uuid.
 */
export function fetchResolvers(id) {
  return {
    type: FETCH_RESOLVERS,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(id)}/resolvers`,
      method: 'get',
    },
  };
}

export function fetchResolverRoles(incidentId) {
  return {
    type: FETCH_RESOLVER_ROLES,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/resolver-roles`,
      method: 'get',
    },
  };
}

export function fetchOrderedResolversAndRoles(incidentId) {
  return {
    type: FETCH_ORDERED_RESOLVERS_AND_ROLES,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/sortable-resolvers`,
      method: 'get',
    },
  };
}

// Change the order of the resolvers in the redux state
// Does not use xm-api
export function changeResolversOrder(dragged, targetIndex) {
  return {
    type: CHANGE_RESOLVERS_ORDER,
    dragged,
    targetIndex,
  };
}

// Save the order of the resolvers
export function saveResolversOrder(incidentId) {
  return (dispatch, getState) => {
    return dispatch({
      type: SAVE_RESOLVERS_ORDER,
      meta: {
        xmApi: true,
        isUriEncoded: true,
        uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/sortable-resolvers`,
        method: 'put',
        params: getState().incidentManagement.incidentDetails.resolversOrder,
      },
    });
  };
}

export function saveIncidentDetails(modifiedIncident) {
  return {
    type: SAVE_INCIDENT_DETAILS,
    meta: {
      xmApi: true,
      uri: ROOT_URL,
      method: 'post',
      params: modifiedIncident,
    },
  };
}

export function saveIncidentDetailsSuccess(payload) {
  return {
    type: SAVE_INCIDENT_DETAILS_SUCCESS,
    payload,
  };
}

export const setIncidentOwner = (incidentId, ownerResolver) => {
  return (dispatch, getState) => {
    return dispatch({
      type: SET_INCIDENT_OWNER,
      ownerResolver,
      meta: {
        xmApi: true,
        uri: ROOT_URL,
        method: 'post',
        params: {
          id: incidentId,
          ownerResolver,
        },
      },
    }).then(() =>
      dispatch(
        saveResolversOrder(
          getState().incidentManagement.incidentDetails.incident.id,
        ),
      ),
    );
  };
};

/**
 * Dismiss a resolver; its state will be changed to `DISMISSED` on the server.
 * @param {string} incidentId
 * @param {string} resolverId - This is the resolver's ID, not the recipient's.
 * @param {string} note - can be `undefined`
 */
export function dismissResolver({ incidentId, resolverId, note }) {
  return {
    type: DISMISS_RESOLVER,
    meta: {
      xmApi: true,
      uri: `${ROOT_URL}/${incidentId}/resolvers/${resolverId}`,
      method: 'post',
      params: {
        state: INCIDENT_RESOLVER_STATE.DISMISSED,
        note,
      },
    },
  };
}

export const removeResolver = ({ incidentUuid, resolverId }) => ({
  type: REMOVE_RESOLVER,
  id: resolverId,
  meta: {
    xmApi: true,
    uri: `${ROOT_URL}/${incidentUuid}/resolvers/${resolverId}`,
    method: 'del',
  },
});

export const renotify =
  ({ incident, resolver }) =>
  dispatch => {
    return dispatch({
      type: RENOTIFY_RESOLVER,
      meta: {
        xmApi: true,
        uri: `${ROOT_URL}/${incident.id}/resolvers/${resolver.id}/resolver-alert`,
        method: 'post',
      },
    });
  };

export const stopNotifyingResolver =
  ({ incidentId, resolver }) =>
  dispatch => {
    return dispatch({
      type: STOP_NOTIFYING_RESOLVER,
      meta: {
        xmApi: true,
        isUriEncoded: true,
        uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/resolvers/${
          resolver.id
        }`,
        method: 'post',
        params: { state: resolver.state },
      },
    });
  };

export const stopNotifyingResolvers =
  ({ incidentId }) =>
  dispatch => {
    return dispatch({
      type: STOP_NOTIFYING_RESOLVERS,
      meta: {
        xmApi: true,
        isUriEncoded: true,
        uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/resolvers`,
        method: 'post',
        params: { state: 'STOPPED' },
      },
    });
  };

export const refreshIncident = refresh => {
  return {
    type: REFRESH_INCIDENT,
    payload: refresh,
  };
};

export const addResolverToRole = (resolverId, roleId, incidentId, position) => {
  return (dispatch, getState) => {
    // If the resolvers order flag is enabled, we don't need to send any data to xm-api until we update the order
    if (isIncidentResolversOrderEnabled(getState())) {
      dispatch({
        type: ADD_RESOLVER_TO_ROLE,
        resolverId,
        roleId,
        position,
      });
      dispatch(saveResolversOrder(incidentId));
    } else {
      dispatch({
        type: ADD_RESOLVER_TO_ROLE,
        resolverId,
        incidentId,
        roleId,
        meta: {
          xmApi: true,
          uri: `${ROOT_URL}/${encodeURIComponent(
            incidentId,
          )}/resolvers/${resolverId}`,
          method: 'post',
          params: {
            role: roleId,
          },
        },
      });
    }
  };
};

export const removeResolverFromRole = (resolverId, position, incidentId) => {
  return dispatch => {
    dispatch({
      type: REMOVE_RESOLVER_FROM_ROLE,
      resolverId,
      position,
    });
    dispatch(saveResolversOrder(incidentId));
  };
};

export const moveResolverBetweenRoles = (
  resolverId,
  toRoleId,
  position,
  incidentId,
) => {
  return dispatch => {
    dispatch({
      type: MOVE_RESOLVER_WITHIN_ROLES,
      resolverId,
      position,
      toRoleId,
    });
    dispatch(saveResolversOrder(incidentId));
  };
};

export const createIncidentRole = (role, resolvers, position = 0) => {
  return (dispatch, getState) => {
    const incidentId =
      getState().incidentManagement.incidentDetails.incident.id;
    return dispatch({
      type: CREATE_INCIDENT_ROLE,
      meta: {
        xmApi: true,
        isUriEncoded: true,
        uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/resolver-roles`,
        method: 'post',
        params: {
          name: role,
        },
      },
      resolvers,
      position,
    }).then(res =>
      isIncidentResolversOrderEnabled(getState())
        ? // We can set order and move resolvers into roles in one request here
          dispatch(saveResolversOrder(incidentId))
        : resolvers.forEach(resolver =>
            dispatch(
              addResolverToRole(resolver.id, res.payload.id, incidentId),
            ),
          ),
    );
  };
};

export const deleteIncidentRole = (roleId, incidentId) => ({
  type: DELETE_INCIDENT_ROLE,
  meta: {
    xmApi: true,
    isUriEncoded: true,
    uri: `${ROOT_URL}/${encodeURIComponent(
      incidentId,
    )}/resolver-roles/${roleId}`,
    method: 'del',
    params: {
      role: roleId,
    },
  },
});

export const renameIncidentRole = (roleId, incidentId, roleName) => ({
  type: RENAME_INCIDENT_ROLE,
  meta: {
    xmApi: true,
    isUriEncoded: true,
    uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/resolver-roles`,
    method: 'post',
    params: {
      id: roleId,
      name: roleName,
    },
  },
});

export const clearIncidentRolesError = () => ({
  type: CLEAR_INCIDENT_ROLE_ERROR,
});

export const setIncidentRolesError = error => ({
  type: SET_INCIDENT_ROLES_ERROR,
  error,
});

export const setMockRole = mockRole => ({
  type: SET_MOCK_ROLE,
  mockRole,
});

/**
 * Add a list of stakeholders to an incident.
 * @param {string} incidentId
 * @param {string[]} stakeholdersIds - An array of recipient IDs.
 */
export function addStakeholders(incidentId, stakeholdersIds) {
  return {
    type: ADD_STAKEHOLDERS,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/stakeholders`,
      method: 'post',
      params: stakeholdersIds,
    },
  };
}

export function fetchStakeholders(incidentId) {
  return {
    type: FETCH_STAKEHOLDERS,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(incidentId)}/stakeholders`,
      method: 'get',
    },
  };
}

// Can only delete 1 by 1
export function deleteStakeholder(incidentId, stakeholderId) {
  return {
    type: DELETE_STAKEHOLDERS,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(
        incidentId,
      )}/stakeholders/${stakeholderId}`,
      method: 'del',
    },
  };
}

// After a DEL call (above), the server doesn't return the stakeholder removed, so client needs to update it locally
export function deleteStakeholderLocally(stakeholderId) {
  return {
    type: DELETE_STAKEHOLDER_LOCALLY,
    payload: {
      stakeholderId,
    },
  };
}

/**
 * Notify all the stakeholders.
 * @param {string} incidentId
 * @param {string} note - mandatory. For now note is incident description. In a follow up story it'll be an actual, user-specified note.
 */
export function notifyStakeholders({ incidentId, note }) {
  return {
    type: NOTIFY_STAKEHOLDERS,
    meta: {
      xmApi: true,
      isUriEncoded: true,
      uri: `${ROOT_URL}/${encodeURIComponent(
        incidentId,
      )}/stakeholders-notification`,
      method: 'post',
      params: {
        note,
      },
    },
  };
}

export function setSelectedServiceOwnerResolver(resolverId) {
  return {
    type: SET_SELECTED_SERVICE_OWNER_RESOLVER,
    payload: {
      resolverId,
    },
  };
}
